/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCustomerList } from '../models';
// @ts-ignore
import type { AdminDashboardHome } from '../models';
// @ts-ignore
import type { Register } from '../models';
// @ts-ignore
import type { User } from '../models';
// @ts-ignore
import type { VerifyRegistration } from '../models';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retorna clientes con cantidad de pedidos completados y total gastado en ecommerce
         * @summary Lista clientes con pedidos y total gastado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAdminCustomersList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/admin/customers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retorna KPIs, series mensuales, ventas por categoria y pedidos recientes para el dashboard
         * @summary Dashboard home admin
         * @param {string} [compareFrom] Fecha inicio comparacion ISO YYYY-MM-DD
         * @param {string} [compareTo] Fecha fin comparacion ISO YYYY-MM-DD
         * @param {string} [from] Fecha inicio ISO YYYY-MM-DD
         * @param {string} [to] Fecha fin ISO YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAdminDashboardHomeRetrieve: async (compareFrom?: string, compareTo?: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/admin/dashboard/home/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (compareFrom !== undefined) {
                localVarQueryParameter['compare_from'] = compareFrom;
            }

            if (compareTo !== undefined) {
                localVarQueryParameter['compare_to'] = compareTo;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el Usuario Actual utilizando el token en el HEADER
         * @summary Obtiene el Usuario Actual utilizando el token en el HEADER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCurrentRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/current/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registrar un nuevo Usuario
         * @summary Registrar un nuevo Usuario
         * @param {Register} register 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterCreate: async (register: Register, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'register' is not null or undefined
            assertParamExists('usersRegisterCreate', 'register', register)
            const localVarPath = `/api/users/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(register, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verificar cuenta y enlazar compras de invitado
         * @param {VerifyRegistration} verifyRegistration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterVerifyCreate: async (verifyRegistration: VerifyRegistration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyRegistration' is not null or undefined
            assertParamExists('usersRegisterVerifyCreate', 'verifyRegistration', verifyRegistration)
            const localVarPath = `/api/users/register/verify/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyRegistration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza la imagen del perfil de usuario
         * @summary Actualiza la imagen de usuario
         * @param {File} [avatar] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUploadImageUpdate: async (avatar?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/upload-image/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (avatar !== undefined) { 
                localVarFormParams.append('avatar', avatar as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza los datos del usuario, solo el usuario puede actualizar sus datos
         * @param {string} username 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserCreate: async (username: string, firstName?: string, lastName?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersUserCreate', 'username', username)
            const localVarPath = `/api/users/user/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (firstName !== undefined) { 
                localVarFormParams.append('first_name', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('last_name', lastName as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.append('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @summary Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserDestroy: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersUserDestroy', 'username', username)
            const localVarPath = `/api/users/user/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la información de un usuario mediante el nombre usuario
         * @summary Obtiene la información de un usuario mediante el nombre usuario
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserRetrieve: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersUserRetrieve', 'username', username)
            const localVarPath = `/api/users/user/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Retorna clientes con cantidad de pedidos completados y total gastado en ecommerce
         * @summary Lista clientes con pedidos y total gastado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersAdminCustomersList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminCustomerList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersAdminCustomersList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersAdminCustomersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retorna KPIs, series mensuales, ventas por categoria y pedidos recientes para el dashboard
         * @summary Dashboard home admin
         * @param {string} [compareFrom] Fecha inicio comparacion ISO YYYY-MM-DD
         * @param {string} [compareTo] Fecha fin comparacion ISO YYYY-MM-DD
         * @param {string} [from] Fecha inicio ISO YYYY-MM-DD
         * @param {string} [to] Fecha fin ISO YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersAdminDashboardHomeRetrieve(compareFrom?: string, compareTo?: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardHome>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersAdminDashboardHomeRetrieve(compareFrom, compareTo, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersAdminDashboardHomeRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtiene el Usuario Actual utilizando el token en el HEADER
         * @summary Obtiene el Usuario Actual utilizando el token en el HEADER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCurrentRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCurrentRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersCurrentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registrar un nuevo Usuario
         * @summary Registrar un nuevo Usuario
         * @param {Register} register 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersRegisterCreate(register: Register, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersRegisterCreate(register, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersRegisterCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verificar cuenta y enlazar compras de invitado
         * @param {VerifyRegistration} verifyRegistration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersRegisterVerifyCreate(verifyRegistration: VerifyRegistration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersRegisterVerifyCreate(verifyRegistration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersRegisterVerifyCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Actualiza la imagen del perfil de usuario
         * @summary Actualiza la imagen de usuario
         * @param {File} [avatar] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUploadImageUpdate(avatar?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUploadImageUpdate(avatar, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUploadImageUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Actualiza los datos del usuario, solo el usuario puede actualizar sus datos
         * @param {string} username 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserCreate(username: string, firstName?: string, lastName?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserCreate(username, firstName, lastName, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUserCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @summary Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserDestroy(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserDestroy(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUserDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtiene la información de un usuario mediante el nombre usuario
         * @summary Obtiene la información de un usuario mediante el nombre usuario
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserRetrieve(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserRetrieve(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUserRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Retorna clientes con cantidad de pedidos completados y total gastado en ecommerce
         * @summary Lista clientes con pedidos y total gastado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAdminCustomersList(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerList>> {
            return localVarFp.usersAdminCustomersList(options).then((request) => request(axios, basePath));
        },
        /**
         * Retorna KPIs, series mensuales, ventas por categoria y pedidos recientes para el dashboard
         * @summary Dashboard home admin
         * @param {UsersApiUsersAdminDashboardHomeRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAdminDashboardHomeRetrieve(requestParameters: UsersApiUsersAdminDashboardHomeRetrieveRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardHome> {
            return localVarFp.usersAdminDashboardHomeRetrieve(requestParameters.compareFrom, requestParameters.compareTo, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el Usuario Actual utilizando el token en el HEADER
         * @summary Obtiene el Usuario Actual utilizando el token en el HEADER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCurrentRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersCurrentRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Registrar un nuevo Usuario
         * @summary Registrar un nuevo Usuario
         * @param {UsersApiUsersRegisterCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterCreate(requestParameters: UsersApiUsersRegisterCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersRegisterCreate(requestParameters.register, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verificar cuenta y enlazar compras de invitado
         * @param {UsersApiUsersRegisterVerifyCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterVerifyCreate(requestParameters: UsersApiUsersRegisterVerifyCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersRegisterVerifyCreate(requestParameters.verifyRegistration, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza la imagen del perfil de usuario
         * @summary Actualiza la imagen de usuario
         * @param {UsersApiUsersUploadImageUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUploadImageUpdate(requestParameters: UsersApiUsersUploadImageUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersUploadImageUpdate(requestParameters.avatar, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza los datos del usuario, solo el usuario puede actualizar sus datos
         * @param {UsersApiUsersUserCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserCreate(requestParameters: UsersApiUsersUserCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersUserCreate(requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @summary Elimina un usuario, solo el usuario se puede eliminar a si mismo
         * @param {UsersApiUsersUserDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserDestroy(requestParameters: UsersApiUsersUserDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersUserDestroy(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la información de un usuario mediante el nombre usuario
         * @summary Obtiene la información de un usuario mediante el nombre usuario
         * @param {UsersApiUsersUserRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserRetrieve(requestParameters: UsersApiUsersUserRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersUserRetrieve(requestParameters.username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersAdminDashboardHomeRetrieve operation in UsersApi.
 * @export
 * @interface UsersApiUsersAdminDashboardHomeRetrieveRequest
 */
export interface UsersApiUsersAdminDashboardHomeRetrieveRequest {
    /**
     * Fecha inicio comparacion ISO YYYY-MM-DD
     * @type {string}
     * @memberof UsersApiUsersAdminDashboardHomeRetrieve
     */
    readonly compareFrom?: string

    /**
     * Fecha fin comparacion ISO YYYY-MM-DD
     * @type {string}
     * @memberof UsersApiUsersAdminDashboardHomeRetrieve
     */
    readonly compareTo?: string

    /**
     * Fecha inicio ISO YYYY-MM-DD
     * @type {string}
     * @memberof UsersApiUsersAdminDashboardHomeRetrieve
     */
    readonly from?: string

    /**
     * Fecha fin ISO YYYY-MM-DD
     * @type {string}
     * @memberof UsersApiUsersAdminDashboardHomeRetrieve
     */
    readonly to?: string
}

/**
 * Request parameters for usersRegisterCreate operation in UsersApi.
 * @export
 * @interface UsersApiUsersRegisterCreateRequest
 */
export interface UsersApiUsersRegisterCreateRequest {
    /**
     * 
     * @type {Register}
     * @memberof UsersApiUsersRegisterCreate
     */
    readonly register: Register
}

/**
 * Request parameters for usersRegisterVerifyCreate operation in UsersApi.
 * @export
 * @interface UsersApiUsersRegisterVerifyCreateRequest
 */
export interface UsersApiUsersRegisterVerifyCreateRequest {
    /**
     * 
     * @type {VerifyRegistration}
     * @memberof UsersApiUsersRegisterVerifyCreate
     */
    readonly verifyRegistration: VerifyRegistration
}

/**
 * Request parameters for usersUploadImageUpdate operation in UsersApi.
 * @export
 * @interface UsersApiUsersUploadImageUpdateRequest
 */
export interface UsersApiUsersUploadImageUpdateRequest {
    /**
     * 
     * @type {File}
     * @memberof UsersApiUsersUploadImageUpdate
     */
    readonly avatar?: File
}

/**
 * Request parameters for usersUserCreate operation in UsersApi.
 * @export
 * @interface UsersApiUsersUserCreateRequest
 */
export interface UsersApiUsersUserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserCreate
     */
    readonly username: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserCreate
     */
    readonly firstName?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserCreate
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserCreate
     */
    readonly email?: string
}

/**
 * Request parameters for usersUserDestroy operation in UsersApi.
 * @export
 * @interface UsersApiUsersUserDestroyRequest
 */
export interface UsersApiUsersUserDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserDestroy
     */
    readonly username: string
}

/**
 * Request parameters for usersUserRetrieve operation in UsersApi.
 * @export
 * @interface UsersApiUsersUserRetrieveRequest
 */
export interface UsersApiUsersUserRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersUserRetrieve
     */
    readonly username: string
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Retorna clientes con cantidad de pedidos completados y total gastado en ecommerce
     * @summary Lista clientes con pedidos y total gastado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersAdminCustomersList(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersAdminCustomersList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retorna KPIs, series mensuales, ventas por categoria y pedidos recientes para el dashboard
     * @summary Dashboard home admin
     * @param {UsersApiUsersAdminDashboardHomeRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersAdminDashboardHomeRetrieve(requestParameters: UsersApiUsersAdminDashboardHomeRetrieveRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersAdminDashboardHomeRetrieve(requestParameters.compareFrom, requestParameters.compareTo, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el Usuario Actual utilizando el token en el HEADER
     * @summary Obtiene el Usuario Actual utilizando el token en el HEADER
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersCurrentRetrieve(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersCurrentRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registrar un nuevo Usuario
     * @summary Registrar un nuevo Usuario
     * @param {UsersApiUsersRegisterCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersRegisterCreate(requestParameters: UsersApiUsersRegisterCreateRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersRegisterCreate(requestParameters.register, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verificar cuenta y enlazar compras de invitado
     * @param {UsersApiUsersRegisterVerifyCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersRegisterVerifyCreate(requestParameters: UsersApiUsersRegisterVerifyCreateRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersRegisterVerifyCreate(requestParameters.verifyRegistration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza la imagen del perfil de usuario
     * @summary Actualiza la imagen de usuario
     * @param {UsersApiUsersUploadImageUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUploadImageUpdate(requestParameters: UsersApiUsersUploadImageUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUploadImageUpdate(requestParameters.avatar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza los datos del usuario, solo el usuario puede actualizar sus datos
     * @param {UsersApiUsersUserCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserCreate(requestParameters: UsersApiUsersUserCreateRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUserCreate(requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un usuario, solo el usuario se puede eliminar a si mismo
     * @summary Elimina un usuario, solo el usuario se puede eliminar a si mismo
     * @param {UsersApiUsersUserDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserDestroy(requestParameters: UsersApiUsersUserDestroyRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUserDestroy(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la información de un usuario mediante el nombre usuario
     * @summary Obtiene la información de un usuario mediante el nombre usuario
     * @param {UsersApiUsersUserRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserRetrieve(requestParameters: UsersApiUsersUserRetrieveRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUserRetrieve(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
}

